import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PaymentReceiptUseView } from "./PaymentReceiptUseView";
import { PaymentReceiptUseViewStore } from "../../store/PaymentReceiptUseViewStore";
import { useStore } from "../../../../hooks";

export const PaymentReceiptUseViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/paymentReceiptUse/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PaymentReceiptUseViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PaymentReceiptUseView paymentReceiptUseViewStore={store} />
      </PageLayout>
    </div>
  );
});
